import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { reviewServices } from "../services/reviewServices";
import { addProductRivewService } from "../services/productReviewServices"; // Import add review service

// Async thunk to fetch product reviews
export const fetchProductReviews = createAsyncThunk(
  "reviews/fetchProductReviews",
  async (
    { last_id = "", limit = 10, product_id, api_token },
    { rejectWithValue }
  ) => {
    try {
      const response = await reviewServices(
        last_id,
        limit,
        product_id,
        api_token
      );
      return response.data; // Adjust according to your actual API response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch reviews"
      );
    }
  }
);

// Async thunk to add a product review
export const addProductReview = createAsyncThunk(
  "reviews/addProductReview",
  async (reviewData, { rejectWithValue }) => {
    try {
      const response = await addProductRivewService(reviewData);
      return response; // Return API response
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add review");
    }
  }
);

// Initial state
const initialState = {
  reviews: null,
  loading: false,
  error: null,
  addingReview: false, // Separate loading state for adding review
  addReviewSuccess: false,
};

const productReviewSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {
    resetReviewState: (state) => {
      state.addingReview = false;
      state.addReviewSuccess = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch product reviews
      .addCase(fetchProductReviews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload; // Store fetched reviews
      })
      .addCase(fetchProductReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add product review
      .addCase(addProductReview.pending, (state) => {
        state.addingReview = true;
        state.addReviewSuccess = false;
        state.error = null;
      })
      .addCase(addProductReview.fulfilled, (state, action) => {
        state.addingReview = false;
        state.addReviewSuccess = true;
        state.reviews = state.reviews
          ? [...state.reviews, action.payload]
          : [action.payload]; // Add new review to the list
      })
      .addCase(addProductReview.rejected, (state, action) => {
        state.addingReview = false;
        state.addReviewSuccess = false;
        state.error = action.payload;
      });
  },
});

export const { resetReviewState } = productReviewSlice.actions;
export default productReviewSlice.reducer;
